import { render, staticRenderFns } from "./accredit.vue?vue&type=template&id=002cc13d&scoped=true&"
import script from "./accredit.vue?vue&type=script&lang=js&"
export * from "./accredit.vue?vue&type=script&lang=js&"
import style0 from "./accredit.vue?vue&type=style&index=0&id=002cc13d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002cc13d",
  null
  
)

export default component.exports